module.exports = __webpack_public_path__ + "media/4x3/ve-b2cd5a9a.svg";